import { Alert, Card, Col, Form, Row } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import autobind from 'autobind-decorator'
import * as React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom'
import { connect } from 'redux-scaffolding-ts'
import { IdentityProps, withIdentity } from 'src/core/services/authentication'
import HttpService from 'src/core/services/http.service'
import ContentTitle from 'src/core/ui/content-header'
import { resolve } from 'src/inversify.config'
import { RestrictionPlanItem, RestrictionPlanStore } from 'src/stores/restriction-plans-store'
import FormEditorView from '../../../components/form-editor'
import { formatMessage } from '../../../core/services/http.service'
import { RestrictionPlanFormBody } from './restriction-plan-form'
import { formItemToRestrictionPlanItem, getWeekHoursItem, RestrictionPlanFormItem } from './utils'
import {UserProfileProps, withUserProfile} from "../../../components/user-profile";

interface RestrictionPlanViewProps
    extends RouteComponentProps<{ companyId: string; restrictionPlanId: string }>,
        UserProfileProps {
    onClose: (id: string | undefined, item?: RestrictionPlanItem) => void
}

interface RestrictionPlanViewState {
    restrictionPlanFormItem: RestrictionPlanFormItem
}

@connect(['restrictionPlan', RestrictionPlanStore])
class RestrictionPlanView extends React.Component<
RestrictionPlanViewProps & WithTranslation & FormComponentProps,
RestrictionPlanViewState
> {
    @resolve(HttpService) private httpService!: HttpService

    private get RestrictionPlanStore() {
        return (this.props as any).restrictionPlan as RestrictionPlanStore
    }

    @autobind
    private load() {
        this.RestrictionPlanStore.changeUrl(this.props.match.params.companyId)
        return this.RestrictionPlanStore.getById(this.props.match.params.restrictionPlanId)
    }

    @autobind
    private isReadOnly() {
        return (this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("CompanyDataViewer")
                && !(this.props.userProfile.roles.includes("Manager")
                    || this.props.userProfile.roles.includes("Administrator")
                    || this.props.userProfile.roles.includes("ClientAdmin")
                    || this.props.userProfile.roles.includes("FIConsultant"))));
    }

    constructor(props: RestrictionPlanViewProps & WithTranslation & FormComponentProps) {
        super(props)

        this.RestrictionPlanStore.changeUrl(this.props.match.params.companyId)
        this.RestrictionPlanStore.createNew({} as any)

        this.state = {
            restrictionPlanFormItem: {
                displayName: '',
                hourRestrictions: {
                    minhours: [],
                    maxhours: []
                }
            }
        }
    }

    componentWillMount(): void {
        if (!this.checkAuth()) this.props.history.push('/')
        this.load().then(item => {
            const { minhours, maxhours } = getWeekHoursItem(item)
            this.setState({
                restrictionPlanFormItem: {
                    displayName: item.displayName,
                    hourRestrictions: {
                        minhours: minhours,
                        maxhours: maxhours
                    }
                } as RestrictionPlanFormItem
            })
        })
    }

    componentWillUpdate() {
        if (!this.checkAuth()) this.props.history.push('/')
    }

    @autobind
    private checkAuth() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("Manager")
                || this.props.userProfile.roles.includes("Administrator")
                || this.props.userProfile.roles.includes("ClientAdmin")
                || this.props.userProfile.roles.includes("FIConsultant")
                || this.props.userProfile.roles.includes("CompanyDataViewer"));
    }

    @autobind
    private handleUpdateItem(values: any) {
        return new Promise((resolve, reject) => {
            this.props.form.validateFields(event => {
                var values = this.props.form.getFieldsValue()
                if (!event) {
                    const itemFromValues = {
                        ...formItemToRestrictionPlanItem(values),
                        companyId: this.props.match.params.companyId,
                        id: this.props.match.params.restrictionPlanId
                    } as RestrictionPlanItem
                    this.RestrictionPlanStore.update(itemFromValues).then(result => {
                        if (result.isSuccess) {
                            resolve()
                        } else {
                            reject()
                        }

                        this.props.history.goBack();
                    })
                }
            })
        })
    }

    public render() {
        const { t } = this.props
        let isReadOnly = this.isReadOnly()
        const { getFieldDecorator, getFieldValue } = this.props.form
        return (
            <div>
                {this.RestrictionPlanStore.state.item && (
                    <Row gutter={0}>
                        <Col span={16}>
                            <ContentTitle
                                type={t('Restriction Plan')}
                                title={this.state.restrictionPlanFormItem.displayName}
                            />
                        </Col>
                    </Row>
                )}
                <Row type={'flex'} align="top" justify="space-between">
                    {this.RestrictionPlanStore.state.result &&
                        !this.RestrictionPlanStore.state.result.isSuccess && (
                            <Alert
                                type="error"
                                message={t('An error has occurred')}
                                description={formatMessage(this.RestrictionPlanStore.state.result)}
                            />
                        )}
                    <Card style={{ width: '100%' }}>
                        <Col span={8}>
                            <FormEditorView
                                onSaveItem={this.handleUpdateItem}
                                onCancel={this.props.history.goBack}
                                showActions={(isReadOnly) ? "Never" :'Always'}
                                form={this.props.form}
                                style={{ maxWidth: 800 }}>
                                <RestrictionPlanFormBody
                                    disabled={isReadOnly}
                                    item={this.state.restrictionPlanFormItem}
                                    getFieldDecorator={getFieldDecorator}
                                    i18n={this.props.i18n}
                                    t={t}
                                    tReady={this.props.tReady}
                                />
                            </FormEditorView>
                        </Col>
                    </Card>
                </Row>
            </div>
        )
    }
}

// Wire up the React component to the Redux store
export default (withUserProfile(withIdentity( withRouter(withTranslation()(Form.create({})(RestrictionPlanView) as any) as any) )) as any) as React.ComponentClass<RestrictionPlanViewProps>
